import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
export const Contact = () => {
  return <section id="contact" className="py-20 bg-white dark:bg-gray-900 transition-colors" data-id="element-43">
      <div className="container mx-auto px-4 md:px-6" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-45">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900 dark:text-white" data-id="element-46">
            Get In Touch
          </h2>
          <div className="w-20 h-1 bg-indigo-600 dark:bg-indigo-400 mx-auto mb-6" data-id="element-47"></div>
          <p className="text-gray-600 dark:text-gray-200 max-w-2xl mx-auto" data-id="element-48">
            Have a project in mind or want to discuss design opportunities? I'd
            love to hear from you. Let's create something amazing together.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-49">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-50">
            <h3 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white" data-id="element-51">
              Contact Information
            </h3>
            <div className="space-y-6" data-id="element-52">
              <div className="flex items-start" data-id="element-53">
                <div className="bg-indigo-100 dark:bg-indigo-900/30 p-3 rounded-lg mr-4" data-id="element-54">
                  <Mail className="text-indigo-600 dark:text-indigo-400" size={24} data-id="element-55" />
                </div>
                <div data-id="element-56">
                  <h4 className="font-bold mb-1 text-gray-900 dark:text-white" data-id="element-57">
                    Email
                  </h4>
                  <p className="text-gray-600 dark:text-gray-200" data-id="element-58">
                    contact@otodesign.com
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-59">
                <div className="bg-indigo-100 dark:bg-indigo-900/30 p-3 rounded-lg mr-4" data-id="element-60">
                  <Phone className="text-indigo-600 dark:text-indigo-400" size={24} data-id="element-61" />
                </div>
                <div data-id="element-62">
                  <h4 className="font-bold mb-1 text-gray-900 dark:text-white" data-id="element-63">
                    Phone
                  </h4>
                  <p className="text-gray-600 dark:text-gray-200" data-id="element-64">
                    +372 5123 4567
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-65">
                <div className="bg-indigo-100 dark:bg-indigo-900/30 p-3 rounded-lg mr-4" data-id="element-66">
                  <MapPin className="text-indigo-600 dark:text-indigo-400" size={24} data-id="element-67" />
                </div>
                <div data-id="element-68">
                  <h4 className="font-bold mb-1 text-gray-900 dark:text-white" data-id="element-69">
                    Location
                  </h4>
                  <p className="text-gray-600 dark:text-gray-200" data-id="element-70">
                    Tallinn, Estonia
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-71">
            <form className="space-y-6" data-id="element-72">
              <div data-id="element-73">
                <label htmlFor="name" className="block text-sm font-medium mb-2 text-gray-900 dark:text-white" data-id="element-74">
                  Name
                </label>
                <input type="text" id="name" className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-indigo-600 dark:focus:ring-indigo-400 focus:border-transparent bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition-colors" placeholder="Your name" data-id="element-75" />
              </div>
              <div data-id="element-76">
                <label htmlFor="email" className="block text-sm font-medium mb-2 text-gray-900 dark:text-white" data-id="element-77">
                  Email
                </label>
                <input type="email" id="email" className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-indigo-600 dark:focus:ring-indigo-400 focus:border-transparent bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition-colors" placeholder="your@email.com" data-id="element-78" />
              </div>
              <div data-id="element-79">
                <label htmlFor="message" className="block text-sm font-medium mb-2 text-gray-900 dark:text-white" data-id="element-80">
                  Message
                </label>
                <textarea id="message" rows={5} className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-indigo-600 dark:focus:ring-indigo-400 focus:border-transparent bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition-colors" placeholder="Tell me about your project..." data-id="element-81"></textarea>
              </div>
              <motion.button type="submit" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full bg-indigo-600 dark:bg-indigo-500 text-white py-3 rounded-md hover:bg-indigo-700 dark:hover:bg-indigo-600 transition-colors font-medium" data-id="element-82">
                Send Message
              </motion.button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
};